var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data_statistics_wrap" },
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { staticClass: "data_statistics_main" }, [
        _c("div", { staticClass: "data_statistics_top" }, [
          _c("div", { staticClass: "data_statistics_con_left" }, [
            _c("div", { staticClass: "platform_access_statistics" }, [
              _c(
                "h2",
                [
                  _c("i", { staticClass: "el-icon-s-data" }),
                  _vm._v(" 平台访问统计 \n            "),
                  _c("span", [_vm._v(_vm._s(_vm.platformVisits.time))]),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.updata } }, [
                    _vm._v("数据更新")
                  ]),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.refresh } }, [
                    _vm._v("刷新")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c("b", [
                    _vm._v(_vm._s(_vm._f("formatStr")(_vm.platformVisits.num)))
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("平台访问人数")])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm._f("formatStr")(_vm.platformVisits.frequency))
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("平台访问频次")])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("b", [
                    _vm._v(_vm._s(_vm._f("formatStr")(_vm.platformVisits.pc)))
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("PC端访问频次")])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("b", [
                    _vm._v(_vm._s(_vm._f("formatStr")(_vm.platformVisits.app)))
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("移动端访问频次")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "online_visits_num" }, [
                _c("p", { staticClass: "online_visits_num_title" }, [
                  _vm._v("在线访问数："),
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("formatStr")(_vm.onlineVisitsNum)))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "broken_line_diagram" },
                  [
                    _c("ve-line", {
                      attrs: {
                        data: _vm.onlineVisitsData,
                        settings: _vm.chartSettings,
                        extend: _vm.peopleExtend,
                        width: "98%",
                        height: "300px",
                        "legend-visible": false,
                        colors: _vm.onlineVisitsColors
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "teaching_behavior_statistics" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm._f("formatStr")(_vm.teachingBehavior.classNum))
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("教学班总数")])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatStr")(_vm.teachingBehavior.courseVisitNum)
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("课程访问频次")])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatStr")(_vm.teachingBehavior.mentoringNum)
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("答疑总数")])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatStr")(
                          _vm.teachingBehavior.sponsorAttendanceNum
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("发起考勤数")])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatStr")(_vm.teachingBehavior.informNum)
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("发布通知数")])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "user_distribution_statistics" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "user_distribution_item" }, [
              _c("div", { staticClass: "user_type_distribution" }, [
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "custom_extend_wrap" },
                  [
                    _c("ve-ring", {
                      attrs: {
                        data: _vm.userTypeData,
                        width: "150px",
                        height: "150px",
                        "data-msg": "type",
                        events: _vm.chartEvents,
                        extend: _vm.chartExtend,
                        settings: _vm.userDistributionSetting,
                        colors: _vm.userTypeColor,
                        title: _vm.userTypeTitle
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "custom_extend" },
                      _vm._l(_vm.userTypeList, function(item, index) {
                        return _c("li", { key: index }, [
                          _c("b", { staticClass: "b_1" }, [
                            _vm._v(_vm._s(item.num))
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.name))])
                        ])
                      }),
                      0
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "user_gender_distribution" }, [
                _c("p", [_vm._v("学生性别分布")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "custom_extend_wrap" },
                  [
                    _c("ve-ring", {
                      attrs: {
                        data: _vm.userGenderData,
                        width: "150px",
                        height: "150px",
                        "data-msg": "sex",
                        events: _vm.chartEvents,
                        extend: _vm.chartExtend,
                        settings: _vm.userDistributionSetting,
                        colors: _vm.userGenderColor,
                        title: _vm.userGenderTitle
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "custom_extend" },
                      _vm._l(_vm.userGenderList, function(item, index) {
                        return _c("li", { key: index }, [
                          _c("b", { staticClass: "b_1" }, [
                            _vm._v(_vm._s(item.num))
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.name))])
                        ])
                      }),
                      0
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user_provinces_distribution" }, [
              _c("p", [_vm._v("学生省份分布")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "custom_extend_wrap" },
                [
                  _c("ve-ring", {
                    attrs: {
                      data: _vm.userProvincesData,
                      width: "150px",
                      height: "150px",
                      "data-msg": "city",
                      events: _vm.chartEvents,
                      extend: _vm.chartExtend,
                      settings: _vm.userProvincesSetting,
                      colors: _vm.userProvincesColor,
                      title: _vm.userProvincesTitle
                    }
                  }),
                  _vm._v(" "),
                  _vm.userProvincesList.length > 0
                    ? _c(
                        "ul",
                        { staticClass: "custom_extend" },
                        _vm._l(_vm.userProvincesList, function(item, i) {
                          return _c("li", { key: i }, [
                            _c("b", { class: "b_" + i }, [
                              _vm._v(_vm._s(item.num))
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.name))])
                          ])
                        }),
                        0
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user_year_distribution" }, [
              _c("p", [_vm._v("学生入学年份分布")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "custom_extend_wrap" },
                [
                  _c("ve-ring", {
                    attrs: {
                      data: _vm.userYearData,
                      width: "150px",
                      height: "150px",
                      "data-msg": "year",
                      events: _vm.chartEvents,
                      extend: _vm.chartExtend,
                      settings: _vm.userYearSetting,
                      colors: _vm.userYearColor,
                      title: _vm.userYearTitle
                    }
                  }),
                  _vm._v(" "),
                  _vm.userYearList.length > 0
                    ? _c(
                        "ul",
                        { staticClass: "custom_extend" },
                        _vm._l(_vm.userYearList, function(item, i) {
                          return _c("li", { key: i }, [
                            _c("b", { class: "b_" + i }, [
                              _vm._v(_vm._s(item.num))
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.name))])
                          ])
                        }),
                        0
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "learning_behavior_statistics" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "learning_behavior_statistics_top" }, [
            _c("ul", [
              _c(
                "li",
                [
                  _c("p", [_vm._v("人均课程进度")]),
                  _vm._v(" "),
                  _c("el-progress", {
                    attrs: {
                      type: "circle",
                      percentage: _vm.studyBehavior.avgCourseSchedule,
                      color: _vm.onlineVisitsColors[0],
                      "stroke-width": 16,
                      "stroke-linecap": "square"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("参与统计学生："),
                    _c("b", [
                      _vm._v(_vm._s(_vm.studyBehavior.avgCourseScheduleNum))
                    ]),
                    _vm._v("人")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("p", [_vm._v("参与讨论度")]),
                  _vm._v(" "),
                  _c("el-progress", {
                    attrs: {
                      type: "circle",
                      percentage: _vm.studyBehavior.discussionDegree,
                      color: _vm.onlineVisitsColors[0],
                      "stroke-width": 16,
                      "stroke-linecap": "square"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("讨论主题总计："),
                    _c("b", [
                      _vm._v(_vm._s(_vm.studyBehavior.discussionDegreeNum))
                    ]),
                    _vm._v("条")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("p", [_vm._v("出勤率")]),
                  _vm._v(" "),
                  _c("el-progress", {
                    attrs: {
                      type: "circle",
                      percentage: _vm.studyBehavior.attendanceRate,
                      color: _vm.onlineVisitsColors[0],
                      "stroke-width": 16,
                      "stroke-linecap": "square"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("考勤次数总计："),
                    _c("b", [_vm._v(_vm._s(_vm.studyBehavior.attendanceNum))]),
                    _vm._v("次")
                  ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "learning_behavior_right" }, [
              _c("div", { staticClass: "learning_behavior_item" }, [
                _c("div", { staticClass: "learning_behavior_item_left" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm._f("filterTime")(_vm.studyBehavior.avgLearnDuration)
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("人均学习时长")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "learning_behavior_item_right" }, [
                  _c("p", [
                    _vm._v("参与统计学生："),
                    _c("b", [
                      _vm._v(_vm._s(_vm.studyBehavior.avgLearnDurationNum))
                    ]),
                    _vm._v(" 人")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "learning_behavior_item" }, [
                _c("div", { staticClass: "learning_behavior_item_left" }, [
                  _c("b", [
                    _vm._v(_vm._s(_vm.studyBehavior.avgOpenNote) + "条")
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("人均公开笔记")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "learning_behavior_item_right" }, [
                  _c("p", [
                    _vm._v("公开笔记总数："),
                    _c("b", [_vm._v(_vm._s(_vm.studyBehavior.openNoteNum))]),
                    _vm._v(" 条")
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "learning_behavior_statistics_bot" }, [
            _c(
              "div",
              { staticClass: "broken_line_diagram" },
              [
                _c("div", { staticClass: "broken_line_diagram_title" }, [
                  _c("p", [
                    _c("span", [_vm._v("日均学习人数：")]),
                    _vm._v(" "),
                    _c("b", [_vm._v(_vm._s(_vm.avgLearnNum))]),
                    _vm._v(" "),
                    _c("span", [_vm._v("累计学习人数：")]),
                    _vm._v(" "),
                    _c("b", [
                      _vm._v(_vm._s(_vm._f("formatStr")(_vm.totalLearnNum)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "b",
                      {
                        class: _vm.learnType == 1 ? "active" : "",
                        on: {
                          click: function($event) {
                            return _vm.tabLearnType(1)
                          }
                        }
                      },
                      [_vm._v("近7日")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b",
                      {
                        class: _vm.learnType == 2 ? "active" : "",
                        on: {
                          click: function($event) {
                            return _vm.tabLearnType(2)
                          }
                        }
                      },
                      [_vm._v("近8周")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b",
                      {
                        class: _vm.learnType == 3 ? "active" : "",
                        on: {
                          click: function($event) {
                            return _vm.tabLearnType(3)
                          }
                        }
                      },
                      [_vm._v("近1年")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.learnChartData.rows.length
                  ? _c("ve-line", {
                      attrs: {
                        data: _vm.learnChartData,
                        settings: _vm.chartSettings,
                        extend: _vm.peopleExtend,
                        width: "98%",
                        height: "350px",
                        "legend-visible": false,
                        colors: _vm.colors
                      }
                    })
                  : _c("div", { staticClass: "no_data" }, [
                      _c("img", {
                        attrs: {
                          src: require("../../../../static/images/wujieguo.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("暂无统计结果")])
                    ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "data_statistics_bot" }, [
          _c("div", { staticClass: "data_statistics_bot_item" }, [
            _vm._m(4),
            _vm._v(" "),
            _c(
              "ul",
              [
                _vm._l(_vm.teacherRanking, function(item, i) {
                  return _c("li", { key: i }, [
                    _c("span", [_vm._v(_vm._s(i + 1))]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.userName))]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("formatStr")(item.visitNum)))
                    ])
                  ])
                }),
                _vm._v(" "),
                _vm._l(10 - _vm.teacherRanking.length, function(item, i) {
                  return _c("li", { key: i + _vm.teacherRanking.length }, [
                    _c("span", [
                      _vm._v(_vm._s(item + _vm.teacherRanking.length))
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("--")]),
                    _vm._v(" "),
                    _c("span", [_vm._v("--")])
                  ])
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "data_statistics_bot_item" }, [
            _vm._m(5),
            _vm._v(" "),
            _c(
              "ul",
              [
                _vm._l(_vm.studentRanking, function(item, i) {
                  return _c("li", { key: i }, [
                    _c("span", [_vm._v(_vm._s(i + 1))]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.userName))]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("formatStr")(item.visitNum)))
                    ])
                  ])
                }),
                _vm._v(" "),
                _vm._l(10 - _vm.studentRanking.length, function(item, i) {
                  return _c("li", { key: i + _vm.studentRanking.length }, [
                    _c("span", [
                      _vm._v(_vm._s(item + _vm.studentRanking.length))
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("--")]),
                    _vm._v(" "),
                    _c("span", [_vm._v("--")])
                  ])
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "data_statistics_bot_item" }, [
            _vm._m(6),
            _vm._v(" "),
            _c(
              "ul",
              [
                _vm._l(_vm.classRanking, function(item, i) {
                  return _c("li", { key: i }, [
                    _c("span", [_vm._v(_vm._s(i + 1))]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.className))]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("formatStr")(item.visitNum)))
                    ])
                  ])
                }),
                _vm._v(" "),
                _vm._l(10 - _vm.classRanking.length, function(item, i) {
                  return _c("li", { key: i + _vm.classRanking.length }, [
                    _c("span", [
                      _vm._v(_vm._s(item + _vm.classRanking.length))
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("--")]),
                    _vm._v(" "),
                    _c("span", [_vm._v("--")])
                  ])
                })
              ],
              2
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _c("i", { staticClass: "el-icon-s-data" }),
      _vm._v(" 教学行为统计")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _c("i", { staticClass: "el-icon-s-data" }),
      _vm._v(" 用户分布统计")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_vm._v("用户类型分布："), _c("b", [_vm._v("300")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _c("i", { staticClass: "el-icon-s-data" }),
      _vm._v(" 学习行为统计")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _c("i", { staticClass: "el-icon-s-data" }),
      _vm._v(" 活跃度TOP教师 "),
      _c("span", [_vm._v("按平台访问频次排序")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _c("i", { staticClass: "el-icon-s-data" }),
      _vm._v(" 活跃度TOP学生 "),
      _c("span", [_vm._v("按平台访问频次排序")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _c("i", { staticClass: "el-icon-s-data" }),
      _vm._v(" 活跃度TOP班级 "),
      _c("span", [_vm._v("按平台访问频次排序")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-413b1f41", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-413b1f41","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/dataStatistics/index.vue
// module id = null
// module chunks = 